import React, { Component } from 'react';
import { $state, $stateParams } from '../../router';
import { Auth, TokenManager, Challenge, ClientManager } from '../../services';
import { GeckoCard, Spinner, GeckoAlert, GeckoBtn } from '../../components';
import { APP_CONST } from '../../constants';


export class SsoCompletePage extends Component {
    state = {
        message: null,
    }

    componentDidMount() {
        if ($stateParams.error_description) {
            this.handleErrorMessage($stateParams.error_description);

        } else {
            Auth.respond(Challenge.SSO, {Code: $stateParams.code})
                .then((data) => this.handleWithToken(data))
                .then(() => {
                    $state.go('selectprofile');
                })
                .catch(err => {});
        }
    }

    /**
     * Store authentication tokens locally
     *
     * @param object data - network response
     *
     * @return Promise - TokenManager instance
     */
    handleWithToken(data) {
        return Promise.resolve(TokenManager.fromResponse(data).persistToLocalStorage());
    }

    handleErrorMessage(raw_error) {
        const safe_error_message = parseErrorMessage(raw_error);

        if (safe_error_message) {
            this.setState({
                message: safe_error_message,
            });
        }
    }

    logout() {
        $state.go('logout', {
            client: ClientManager.client(),
            app: ClientManager.app(),
        });
    }

    renderMessage(message) {
        if (!message) {
            return null;
        }

        return (
            <div className="d-flex flex-column">
                <div style={{marginBottom: 10}}>
                    <GeckoAlert type={APP_CONST.ALERT_TYPE_INFO}>
                        {message}
                    </GeckoAlert>
                </div>

                <GeckoBtn
                    name="Go To Login"
                    type={APP_CONST.BTN_TYPE_SUCCESS}
                    handler={this.logout.bind(this)}
                    className="float-left d-flex align-self-center"
                    style={{marginLeft: 0, marginBottom: 10}}
                />
            </div>
        );
    }

    renderSpinner(active) {
        if (!active) {
            return null;
        }

        return (
            <div className="row text mt-3 mb-3">
                <div className="col d-flex flex-column align-items-center">
                    <Spinner size="small" color="blue" />
                </div>
            </div>
        )
    }

    render() {
        const activeSpinner = (this.state.message ? false : true);

        return (
            <GeckoCard padded={true}>

                {this.renderMessage(this.state.message)}

                {this.renderSpinner(activeSpinner)}
                
            </GeckoCard>
        );
    }

}

export const parseErrorMessage = (raw_error) => {
    const error = decodeURIComponent(raw_error.replace(/\+/g, '%20'));

    const message_parts = error.split('::');

    if (message_parts[1]) {
        return message_parts[1].trim();
    }

    return error;
}


export default SsoCompletePage;
